import { observer } from 'mobx-react-lite';
import React from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

export default observer(function ServerError() {
    const { commonStore } = useStore();
    let errorMessage = '';
    let errorDetails = '';
    if (commonStore.error) {
        errorMessage = commonStore.error.message;
        errorDetails = commonStore.error.details;
    }

    return (
        <Container>
            <Header as='h1' content='Server Error' />
            <Header sub as='h5' color='red' content={errorMessage} />
            {errorDetails &&
                <Segment>
                    <Header as='h4' content='Stack trace' color='teal' />
                    <code style={{ marginTop: '10px' }}>{errorDetails}</code>
                </Segment>
            }
        </Container>
    )
})